module.exports = __webpack_public_path__ + "static/media/pro_1.1ac51840.jpg";